import { TextField, type TextFieldProps } from "@mui/material";

import { useFieldContext } from "components/Forms/AppForm";

type TextInputProps = TextFieldProps & {
  label: string;
};

const TextInput = ({ label, ...props }: TextInputProps) => {
  const field = useFieldContext<string>();

  const isValid = field.state.meta.errors.length === 0;
  const errors = field.state.meta.errors.map((err) => err?.message);

  return (
    <TextField
      value={field.state.value}
      onChange={(e) => field.handleChange(e.target.value)}
      id={`text-input-${label}`}
      label={label}
      variant="outlined"
      size="small"
      fullWidth
      error={!isValid}
      helperText={errors.map((err) => (
        <div key={err}>{err}</div>
      ))}
      {...props}
    />
  );
};
export default TextInput;
